'use client'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/components/ui/dialog'
import FreeUserCompanyFilters from '@/app/[lng]/(home)/search/(Filters)/CompanyFilters/FreeUserCompanyFilters'
import FreeUserClearAllFilter from '@/app/[lng]/(home)/search/(Filters)/CommonFilters/FreeUserClearAllFilter'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/app/globalRedux/store'
import { setModalOpen } from '@/app/globalRedux/userStore/userStore'
import { setDoNotFetchForModal } from '@/app/globalRedux/userStore/userStore'
import useLocalizedRouter from '@/app/hooks/useLocalizedRouter'
import { useTranslation } from '@/app/i18n/client'
import RetailCompanyFilters from '@/app/[lng]/(home)/retails/companies/[[...companyPageNo]]/(components)/RetailCompanyFilters'
import { usePathname } from 'next/navigation'
import { setCompanyFiltersToInitialState } from '@/app/globalRedux/filter/companyFilter'
import { clearFilters } from '@/app/globalRedux/filter/newsFilter'
import { setProductFiltersToInitialState } from '@/app/globalRedux/filter/productFilter'
import { setCommonFilterToInitalState } from '@/app/globalRedux/filter/commonFilter'
import { clearRetailNewsFilter } from '@/app/globalRedux/filter/retail/retailnewsFilter'
import { clearRetailCompaniesFilter } from '@/app/globalRedux/filter/retail/retailCompanyFilter'

const FreeUserFilterModal = ({
  display,
  to,
  search,
  retailCompanyResponse,
}: {
  display: string
  to: string
  search: string
  retailCompanyResponse: any
}) => {
  const dispatch = useDispatch()
  const pushWithLocale = useLocalizedRouter()
  const { t } = useTranslation()
  const user = useSelector((state: RootState) => state.user)
  const pathname = usePathname()
  const retail = pathname.includes('/retails/companies/')

  const clearFilter = () => {
    dispatch(clearFilters())
    dispatch(setCompanyFiltersToInitialState())
    dispatch(setProductFiltersToInitialState())
    dispatch(setCommonFilterToInitalState())
    dispatch(clearRetailNewsFilter())
    dispatch(clearRetailCompaniesFilter())
  }

  const handleOpenChange = (open: boolean) => {
    dispatch(setModalOpen(open))
    dispatch(setDoNotFetchForModal(true))
  }
  const handleSubmit = () => {
    dispatch(setModalOpen(false))
    dispatch(setDoNotFetchForModal(false))
  }

  const handleGoHome = () => {
    dispatch(setDoNotFetchForModal(true))
    dispatch(setModalOpen(false))
    pushWithLocale(`${to}`)
    clearFilter()
  }

  return (
    <Dialog open={user.modalOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button className="w-full mb-4" variant="outline">
          {t('Change Filters')}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="border-0 p-0 !max-w-[1080px] bg-[white] h-[90%] flex flex-col"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        hideCloseIcon={false}
      >
        <div className="flex-1 overflow-y-auto">
          <DialogHeader className="h-fit bg-modal_header">
            <div className=" flex items-center relative justify-center w-full py-4">
              <p className="font-bold text-2xl">{t('Filter')}</p>
              <div className="cursor-pointer absolute right-4 flex items-center ml-auto">
                <FreeUserClearAllFilter />
              </div>
            </div>
          </DialogHeader>

          <div className=" overflow-y-scroll text-sm p-2 px-3">
            {retail ? (
              <div className="pt-4">
                <RetailCompanyFilters
                  companyData={retailCompanyResponse}
                  modalApplicable={false}
                  showClearAll={false}
                  modalFilterLayout={true}
                />
              </div>
            ) : (
              <FreeUserCompanyFilters search={search} />
            )}
          </div>
        </div>
        <div>
          <div className=" border border-1 flex justify-end gap-4 bg-modal_header py-4 px-4 tracking-wide bg-grey-300">
            <Button className="text-white" onClick={handleGoHome}>
              {t(`${display}`)}
            </Button>
            <Button className="text-white" onClick={handleSubmit}>
              {t('Submit')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default FreeUserFilterModal
